import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/router";
import store from "./store/store";
import axios from "axios";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

//Set default axios header an base URL
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.baseURL = process.env.VUE_APP_BACK_URL + "/api";

//If a token is stored in localstorage, try to use it
const adminToken = window.localStorage.getItem("adminAuthToken");
if (adminToken) {
	//Save the token in the store
	store.commit("admin/saveToken", adminToken);
	//Set headers to use the token
	axios.defaults.headers.common["AdminAuthorization"] = adminToken;
}

//If a token is stored in localstorage, try to use it
const userToken = window.localStorage.getItem("userAuthToken");
if (userToken) {
	//Save the token in the store
	store.commit("user/saveToken", userToken);
	//Set headers to use the token
	axios.defaults.headers.common["Authorization"] = userToken;
}

import "leaflet/dist/leaflet.css";

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount("#app");

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 503) {
			window.location.replace("/maintenance.html");
			return Promise.reject("Servidor en mantenimiento");
		} else {
			return Promise.reject(error);
		}
	}
);
